export default __webpack_public_path__ + "static/media/list-nested-icon-green.9df7b67c.svg";